import { render, staticRenderFns } from "./back_gum_type.vue?vue&type=template&id=7a9f6ed8&scoped=true"
import script from "./back_gum_type.vue?vue&type=script&lang=js"
export * from "./back_gum_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f6ed8",
  null
  
)

export default component.exports